/**
 * Modern filter pills with subtle status colors.
 * Default: white bg + light border. Selected: solid colored bg.
 */
const STYLES = {
  active: {
    selected: "bg-[#10B981] text-white border-[#10B981]",
    dot: "bg-[#10B981]",
  },
  pending: {
    selected: "bg-[#F59E0B] text-white border-[#F59E0B]",
    dot: "bg-[#F59E0B]",
  },
  rejected: {
    selected: "bg-[#EF4444] text-white border-[#EF4444]",
    dot: "bg-[#EF4444]",
  },
  suspended: {
    selected: "bg-[#F97316] text-white border-[#F97316]",
    dot: "bg-[#F97316]",
  },
  archived: {
    selected: "bg-[#64748B] text-white border-[#64748B]",
    dot: "bg-[#94A3B8]",
  },
  total: {
    selected: "bg-[#3B82F6] text-white border-[#3B82F6]",
    dot: "bg-[#3B82F6]",
  },
  default: {
    selected: "bg-[#3B82F6] text-white border-[#3B82F6]",
    dot: "bg-[#94A3B8]",
  },
};

export function FilterPills({ tabs, value, onChange, counts = {}, testId }) {
  return (
    <div className="flex flex-wrap gap-2 mb-6" data-testid={testId}>
      {tabs.map((t) => {
        const isActive = value === t.key;
        const style = STYLES[t.key] || STYLES.default;
        const count = counts[t.key];
        return (
          <button
            key={t.key}
            onClick={() => onChange(t.key)}
            data-testid={`${testId || "filter"}-${t.key}`}
            className={`inline-flex items-center gap-2 px-3.5 h-9 rounded-full border text-sm font-medium transition-colors ${
              isActive
                ? style.selected
                : "bg-white text-[#334155] border-[#E5E7EB] hover:border-[#CBD5E1] hover:bg-[#F8FAFC]"
            }`}
          >
            {!isActive && <span className={`inline-block w-1.5 h-1.5 rounded-full ${style.dot}`} />}
            <span>{t.label}</span>
            {count !== undefined && count !== null && (
              <span
                className={`text-xs font-semibold ${
                  isActive ? "text-white/85" : "text-[#94A3B8]"
                }`}
              >
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
